module.exports = __webpack_public_path__ + "img/internet-box-login-tile.1f80c1f7.png";